import CommonCustomScrollbar from 'components/CustomScrollbar';
import CommonInput from 'components/Input';
import { Stack } from 'components/Stack';
import styled from 'styled-components';
import { mediaBreakpointDown } from 'styles/grid';

const isMobile = mediaBreakpointDown.sm;

const Container = styled.div<{ isMobile: boolean; isShow: boolean }>`
  display: ${({ isShow }) => (isShow ? 'flex' : 'none')};
  flex: 1;
`;

const DropOffLocationsContainer = styled(Stack).attrs({
  direction: 'column',
})<{ isMapAvailable: boolean }>`
  ${isMobile} {
    flex: 1;
    padding: 16px 10px;
    min-height: 404px;
  }

  flex: ${({ isMapAvailable }) => (isMapAvailable ? 0.4 : 1)};
  padding: 24px 16px;
  height: 500px;
`;

const CustomScrollbar = styled(CommonCustomScrollbar)`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const InputContainer = styled.div`
  width: 100%;
`;

const Input = styled(CommonInput)`
  width: 100%;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  display: flex;
`;

const MapViewContainer = styled(Stack).attrs({
  align: 'center',
  justify: 'center',
})`
  flex: 0.6;
  border-left: 0.5px solid #d9d9d9;
  padding: 16px;
`;

export {
  Container,
  CustomScrollbar,
  DropOffLocationsContainer,
  IconWrapper,
  Input,
  InputContainer,
  MapViewContainer,
};
